module.exports = __webpack_public_path__ + "html/column-block.component.html";